<template>
  <div class="Account">
    <div class="panel">
      <div class="img">
        <my_image :src="sideImg" :height="'34vw'"></my_image>
      </div>
      <div>
        <login v-if="type == 'login'"></login>
        <login_with_code v-if="type == 'loginWithCode'"></login_with_code>
        <register v-if="type == 'register'"></register>
        <password v-if="type == 'password'"></password>
        <certification v-if="type == 'certify'"></certification>
        <modify_info v-if="type =='modify'"></modify_info>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
 import MyImage from '@/components/Image.vue';
 import Login from '@/components/account/Login.vue'
 import LoginWithCode from '@/components/account/LoginWithCode.vue'
 import Register from '@/components/account/Register.vue'
 import Password from '@/components/account/Password.vue'
 import Certification from '@/components/account/Certification.vue'
 import ModifyInfo from '@/components/account/ModifyInfo.vue'

export default {
  name: 'Account',
   computed: {
     sideImg() {
       return '/oss/images/account/sideImg.png'
     },
     type () {
       return this.$route.params.type
     }
   },
   components: {
     my_image: MyImage,
     login: Login,
     register: Register,
     login_with_code: LoginWithCode,
     password: Password,
     certification: Certification,
     modify_info: ModifyInfo
  }
}
</script>

<style scoped>
 .Account{
   background: #373e49;
   width: 100vw;
   height: 100vh;
   display: flex;
   align-items: center;
   justify-content: center;
 }
 .panel{
   width:62.6vw;
   height: 34.0625vw;
   display: flex;
 }
 .img {
   display: flex;
   align-items: center;
 }

 @media (min-width: 320px) and (max-width: 480px) {
   .Account{
     height: 100vh;
   }
   .img{
     display: none;
   }
 .panel{
   width: 100vw;
   height: 100vh;
   display: flex;
 }


 }
</style>
